import { logger } from "@creditas/home-mf-shared";
import { camelizeKeys } from "humps";
import { ROOT_LOG_PREFIX } from "../../utils/consts";

const EMBER_AUTH_SESSION = "ember_simple_auth-session";
const LOG_PREFIX: string = "[AuthenticationService]";

export const getAuthenticatedData = (): any => {
  try {
    const rawSessionDataString = localStorage.getItem(EMBER_AUTH_SESSION);
    if (rawSessionDataString === null)
      throw Error("Session data was not found");

    const rawSessionData = JSON.parse(rawSessionDataString);

    if (Object.keys(rawSessionData.authenticated).length === 0) {
      throw Error("Session data was not filled");
    }

    const sessionData = camelizeKeys(rawSessionData);

    return sessionData.authenticated;
  } catch (error: any) {
    logger.error({
      message: `[${ROOT_LOG_PREFIX}]${LOG_PREFIX} Session data failed to get from localStorage`,
      error,
    });
    return null;
  }
};

const parseJwt = (token: string): any => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("")
  );

  return JSON.parse(jsonPayload);
};

const epochTimeToDate = (epochTime: number): Date => {
  const authenticationExpiredAt = new Date(0);
  authenticationExpiredAt.setUTCSeconds(epochTime);

  return authenticationExpiredAt;
};

const getExpiresInFromAccessToken = (accessToken: string): string => {
  const accessTokenDecoded = parseJwt(accessToken);
  const { exp } = accessTokenDecoded;

  return exp;
};

export const getAccessToken = (): string | null => {
  try {
    const { accessToken } = getAuthenticatedData();

    return accessToken;
  } catch {
    return null;
  }
};

export const getRefreshToken = (): string | undefined => {
  try {
    const authenticatedData = getAuthenticatedData();
    const { refreshToken } = authenticatedData;
    if (!refreshToken)
      throw Error(
        `Refresh token was not found on authenticatedData: ${JSON.stringify(
          authenticatedData
        )}`
      );

    return refreshToken;
  } catch (error: any) {
    logger.error({
      message: `[${ROOT_LOG_PREFIX}]${LOG_PREFIX} Refresh token failed to get from localStorage`,
      error,
    });
    return undefined;
  }
};

export const isAccessTokenExpired = (): boolean => {
  const accessToken = getAccessToken();
  const expiresIn = getExpiresInFromAccessToken(accessToken || "");
  const expiresInDateFormat = epochTimeToDate(Number(expiresIn));

  return new Date() > expiresInDateFormat;
};
